import React, { Component } from 'react';
import '../style/AccessibilityEnhancement.css'
import Card from './Layout/Card';
import ReactLoading from "react-loading";
import OutputText from './OutputText';
import Explication from './Explication';
import Authenticator from './Authenticator';
import Accordion from './Accordion';


export default class FarBafForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isResponseReceived: false,
            textAreaMaxLength: 5000,
            textAreaPlaceholder: "Insérer une vidéodescription brute ou en format timestamp ( timestamp et ligne de texte séparée par une tabulation). Vidéodescription complète ou un extrait",
            textAreaLenght: 0,
            textarea: "",
            showInformation: false,
            seuilChaineCoref: 5,
            longueur: 40,
            seuilRepetitionMinimal: 2,
            fenetreDuplication: 2,
            listPostTag: ["ADV", "VERB", "ADJ"],
            temps: "strict",
            vocCinema: "",
            vocOffensant: "",
            lexiquePersonel: "",
            apiKey: "",
            loading: false,
            response: null
        };


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.get_form_data = this.get_form_data.bind(this);
        this.start_loading = this.start_loading.bind(this);
        this.stop_loading = this.stop_loading.bind(this);
        this.outputParameters = this.outputParameters.bind(this);
        this.handleFileRead = this.handleFileRead.bind(this);
        this.handleFileChosen = this.handleFileChosen.bind(this);
    }



    get_form_data() {
        return {
            "text": this.state.textarea,
            "maxCorefLength": this.state.seuilChaineCoref,
            "maxLength": this.state.longueur,
            "seuilDuplication": this.state.seuilRepetitionMinimal,
            "windowDuplication": this.state.fenetreDuplication,
            "temps": this.state.temps,
            "postTagRepetition": this.state.listPostTag,
            "vocCinema": this.state.vocCinema,
            "vocOffensant": this.state.vocOffensant,
            "lexiquePerso": this.state.lexiquePersonel,
        }
    }


    start_loading() {
        this.setState({ loading: true })
    }

    stop_loading() {
        this.setState({ loading: false })
    }

    handleSubmit(event) {
        event.preventDefault(); // Prevent the refresh of the page, because base html forms refresh automatically the current page
        let form_data = this.get_form_data()
       
        let url = 'https://vdqual.crim.ca/vdqual/predict'

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': "Bearer "+ this.state.apiKey,
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify(form_data),
        })
            .then((this.start_loading()))
            .then((this.setState({ isResponseReceived: false })))
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.error)
                }
                this.stop_loading()
                return response.json();
            })
            .then((result) => {
                this.setState({ response: result })
                this.setState({ isResponseReceived: true })
            })
            .catch((err) => {
                this.stop_loading()
            });

    }


    handleFileRead(event, fileName) {
        const content = event.target.result;
        this.setState({[fileName]: content });
    }
    
    handleFileChosen(event, fileName) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onloadend = (event) => this.handleFileRead(event, fileName);
        reader.onerror = (event) => alert(event.target.error.name);
        reader.readAsText(file);
    }



    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "textAreaFile") {
            this.handleFileChosen(event, "textarea")
        }
        else if (["vocCinema", "vocOffensant"].includes(name)){
            this.handleFileChosen(event, name)
        }
        else if (name === "tempsStrict") {
            this.setState({ temps: "strict" })
        }
        else if (name === "tempsRegulier") {
            this.setState({ temps: "regulier" })
        }
        else if (name === "listPostTag") {
            let postTags = value.toUpperCase().split(",")
            this.setState({ listPostTag: postTags })
        }
        else {
            this.setState({ [name]: value })
        }

    }


    outputParameters() {
        return (
            <Card title="Filtres et Paramètres">
                <fieldset>
                    {/* <legend>Filtres et Paramètres</legend> */}
                    <div className='input-container'>
                        <label htmlFor="longueurInput"> Longueur :</label>
                        <input id="longueurInput" name="longueur" type="number" value={(this.state.longueur)} onChange={this.handleInputChange} />
                    </div>
                    <br />
                    {/* <div className='input-container'> Répétition : </div> */}
                    <fieldset>
                        <legend> Répétition :</legend>
                        <div className='input-container-multi'>
                            <div className='input-container'>
                                <label htmlFor='seuilRepetitionMininalInput'> Seuil minimal :</label>
                                <input id="seuilRepetitionMininalInput" name="seuilRepetitionMinimal" type="number" value={(this.state.seuilRepetitionMinimal)} onChange={this.handleInputChange} />
                            </div>
                            <br/>
                            <div className='input-container'>
                                <label htmlFor='fenetreDuplicationInput'> Taille de la fenêtre : </label>
                                <input id="fenetreDuplicationInput" name="fenetreDuplication" type="number" value={(this.state.fenetreDuplication)} onChange={this.handleInputChange} />
                            </div>
                            <br/>
                            <div className='input-container'>
                                <label htmlFor='listPostTag'> Liste de post-tag : </label>
                                <input name="listPostTag" className='listPostTag' type="text" placeholder='[ADV, VERB, ADJ]' value={(this.state.listPostTag)} onChange={this.handleInputChange} />
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend> Temps pas au présent ind.: </legend>
                        <div className='input-container-multi'>
                            <div>
                                <input id="tempsSctrictInput" name="tempsStrict" type="checkbox" onChange={this.handleInputChange} checked={this.state.temps === "strict"} />
                                <label htmlFor='tempsSctrictInput'> Strict </label>
                            </div>
                            <div>
                                <input id="tempsRegulierInput" name="tempsRegulier" type="checkbox" onChange={this.handleInputChange} checked={this.state.temps === "regulier"} />
                                <label htmlFor='tempsRegulierInput'> Régulier </label>
                            </div>
                        </div>
                    </fieldset>
                    <div className='input-container'>
                        <label htmlFor='seuilChaineCorefInput'> Seuil chaîne de coréférence  :</label>
                        <input id="seuilChaineCorefInput" name="seuilChaineCoref" type="number" value={this.state.seuilChaineCoref} onChange={this.handleInputChange} />
                    </div>
                    <br />
                    <div className='input-container' >
                        <label htmlFor='vocCinemaInput'> Vocabulaire cinématographique (.csv) :</label>
                        <input id='vocCinemaInput' name="vocCinema" type="file" onChange={this.handleInputChange} accept=".csv" />
                    </div>
                    <div className='input-container'>
                        <label htmlFor='vocOffensantInput'> Vocabulaire offensant (.csv) :</label>
                        <input id='vocOffensantInput' name="vocOffensant" type="file" onChange={this.handleInputChange} accept=".csv" />
                    </div>
                </fieldset>
            </Card>
        )
    }

    render() {
        return (
            <div>
                <div>
                    <form onSubmit={this.handleSubmit}>
                        <Card title="Insérer une vidéodescription">
                            <fieldset>
                                <label htmlFor="textarea">Vidéodescription:</label>
                                <textarea name="textarea" placeholder={this.state.textAreaPlaceholder} value={this.state.textarea} onChange={this.handleInputChange} spellCheck="false"/>
                                <div className='input-container'>
                                    <label htmlFor="textAreaFileInput">Choisir un fichier texte (.txt) :</label>
                                    <input id='textAreaFileInput' name="textAreaFile" type="file" onChange={this.handleInputChange} accept=".txt" />
                                </div>
                            </fieldset>
                        </Card>
                        {this.outputParameters()}
                        <div>
                            {(!this.state.loading) ?
                                <div className='submit-container'>
                                    <div className='input-container'>
                                        <label htmlFor='apiKeyInput'> Insérer la clé d'accès : </label>
                                        <input name="apiKey" className='api-Key-input' type="text" placeholder="Ex.: 08jhnf4.." value={(this.state.apiKey)} onChange={this.handleInputChange} />
                                    </div>
                                    <input name="analyser-button" className='analyser-button' type="submit" value="Analyser" aria-label="Analyser le text passer en entrée"  disabled={this.state.loading} />
                                </div>
                                :
                                (<div style={{ display: "flex", justifyContent: "center" }}><ReactLoading type={'bars'} color="#1978a5" /> </div>)}
                        </div>
                    </form>
                </div>
                <div>
                    {this.state.isResponseReceived && (
                        <OutputText inputs={this.get_form_data()} response={this.state.response}></OutputText>
                    )}
                </div>
                <br/>
            </div>
        )
    }

}